import GeneralErrorPlaceholderSvg from '@/../img/placeholders/general-error-placeholder.svg';
import { GenericErrorPlaceholder, NAV_OPTIONS } from '@/placeholders';
import { CleanModal } from '@/widgets/components/clean-modal';
import styled from 'styled-components';
import { BaseErrorBoundary } from './base-error-boundary';
import { ERROR_TYPES } from './errors';

const ModalBackground = styled.div`
  height: 100%;
  width: 100%;
  background-color: #f6f9ff;
`;

const ErrorMessageHeaderText = () => (
  <>
    <span>Oops,</span>
    <br />
    <span>we are currently unable to display this property.</span>
  </>
);

const ErrorMessageSubtext = () => (
  <>
    <span>Click back to return to previous page</span>
  </>
);

/**
 * Error boundary with behavior specific to errors caught from property details modal.
 * Errors will be caught either on mount or on modal open
 *
 * @export
 * @class PropertyDetailsErrorBoundary
 * @extends {BaseErrorBoundary}
 */
export class PropertyDetailsErrorBoundary extends BaseErrorBoundary {
  // Reset the error flag when user navigates away
  resetErrorStateOnBack = () => {
    this.setState({ hasError: false });
  };

  render() {
    const { active } = this.props;
    if (this.state.hasError) {
      // Error on modal open
      if (active) {
        return (
          <CleanModal active={active}>
            <ModalBackground>
              <GenericErrorPlaceholder
                renderErrorMessageHeaderText={<ErrorMessageHeaderText />}
                renderErrorMessageSubtext={<ErrorMessageSubtext />}
                renderErrorImage={
                  <GeneralErrorPlaceholderSvg height={329} width={680} />
                }
                renderNavigationOptions={[NAV_OPTIONS.Back]}
                optionalNavCB={this.resetErrorStateOnBack}
              />
            </ModalBackground>
          </CleanModal>
        );
      }
      // Error on mount
      this.alert(ERROR_TYPES.DefaultException, 'error', 5000);
      return null;
    }
    return this.props.children;
  }
}
